import { render, staticRenderFns } from "./ResolumeWidget.vue?vue&type=template&id=0cbe1a97&scoped=true"
import script from "./ResolumeWidget.vue?vue&type=script&lang=js"
export * from "./ResolumeWidget.vue?vue&type=script&lang=js"
import style0 from "./ResolumeWidget.vue?vue&type=style&index=0&id=0cbe1a97&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbe1a97",
  null
  
)

export default component.exports